export const colorMapping: { [key: string]: { fill: string; backgroundColor: string } } = {
    'New': { fill: '#318FE0', backgroundColor: '#DFF0FF' },
    'Pending': { fill: '#000000', backgroundColor: '#CCCCCC' },
    'Resolved': { fill: '#008528', backgroundColor: '#DDFFE7' },
    'Closed': { fill: '#008528', backgroundColor: '#DDFFE7' },
    'Reopened': { fill: '#A60A30', backgroundColor: '#F7D5DD' },
    'Open': { fill: '#A60A30', backgroundColor: '#F7D5DD' },
    'In progress': { fill: '#000000', backgroundColor: '#CCCCCC' },
  };